<template>
    <div>
      <languages-form 
       :is-languages-form-sidebar-active.sync="isLanguagesFormSidebarActive"
        :languages-data="languagesData"
        @refetch-data="refetchData" 
       />
        <b-card no-body>
            <div class="m-2">
                <b-row>
                    <b-col
                    cols="12"
                    md="6"
                    class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                >

                    
                </b-col>
                <b-col
                  cols="12"
                  md="6"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <b-button
                      variant="primary"
                      @click="addLanguages({})"
                    
                    >
                      <span class="text-nowrap">Add Language</span>
                    </b-button>
                  </div>
                </b-col>
                </b-row>
                
            </div>
            <div class="m-2">
                <b-table
                  ref="refListTable"
                  :items="fetchData"
                  responsive
                  :fields="tableColumns"
                  
                  :sort-by.sync="sortBy"
                  show-empty
                  empty-text="No matching records found"
                  :sort-desc.sync="isSortDirDesc"
                  class="position-relative"
              >
              <template #cell(is_active)="data">
                <b-badge
                    pill
                    :variant="`light-${resolveStatusVariant(data.item.is_active)}`"
                    class="text-capitalize"
                >
                    {{ resolveStatusnameVariant(data.item.is_active) }} 
                </b-badge>
            </template>
            <template #cell(action)="data">
                
                <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateData(data.item)" class="ml-1" variant="outline-success"><feather-icon icon="EditIcon" /></b-button>
                <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(data.item.id)" variant="outline-danger"><feather-icon icon="XIcon" /></b-button>

            </template>
              </b-table>
        <b-row>
                <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                    <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                </b-col>
                <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >
                      <b-pagination
                          v-model="currentPage"
                          :total-rows="totals"
                          :per-page="perPage"
                          first-number
                          last-number
                          class="mb-0 mt-1 mt-sm-0"
                          prev-class="prev-item"
                          next-class="next-item"
                      >
                          <template #prev-text>
                              <feather-icon
                                  icon="ChevronLeftIcon"
                                  size="18"
                              />
                              </template>
                              <template #next-text>
                              <feather-icon
                                  icon="ChevronRightIcon"
                                  size="18"
                              />
                          </template>
                      </b-pagination>
                  </b-col>
              </b-row>
            </div>
          
        </b-card>
    </div>
</template>
<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
//api
import axios from '@axios'
import store from '@/store'


import { ref,onUnmounted } from '@vue/composition-api'
import useLanguagesList from './useLanguagesList'

import languagesStoreModule from '../languagesStoreModule'
import LanguagesForm from '../languages-form/LanguagesForm.vue'
export default {
    components: {
        BCard,
        BRow,
        BCol,
        BFormInput,
        BButton,
        BTable,
        BMedia,
        BAvatar,
        BLink,
        BBadge,
        BDropdown,
        BDropdownItem,
        BPagination,
        BTooltip,
        VBModal,
        BFormGroup,
        BFormCheckbox,
        vSelect,
        LanguagesForm
    },
    directives:{
        'b-modal': VBModal,
        Ripple

    },
    setup() {
      const LANGUAGES_STORE_MODULE_NAME = 'app-languages';
      if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule)
        onUnmounted(() => {
            if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGES_STORE_MODULE_NAME)
        });
      const {
        fetchData,
        tableColumns,
        perPage,
        currentPage,
        totals,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refListTable,
    
        statusFilter,
    
        addLanguages,
        languagesData,
        refetchData,
        deleteData,
        resolveStatusVariant,
        resolveStatusnameVariant,
        isLanguagesFormSidebarActive,
        updateData

      } = useLanguagesList();

      return {

        fetchData,
        tableColumns,
        perPage,
        currentPage,
        totals,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refListTable,
    
        statusFilter,
    
        addLanguages,
        languagesData,
        refetchData,
        deleteData,
        resolveStatusVariant,
        resolveStatusnameVariant,
        isLanguagesFormSidebarActive,
        updateData

      }
    
    },
    methods:{
      deleteconfirm(id){
          this.$bvModal
              .msgBoxConfirm('Please confirm that you want to delete Language ID.'+id, {
              title: 'Please Confirm',
              size: 'sm',
              okVariant: 'danger',
              okTitle: 'Yes',
              cancelTitle: 'No',
              cancelVariant: 'outline-secondary',
              hideHeaderClose: false,
              centered: true,
              })
              .then(value => {
              if(value === true){
              this.deleteData(id)
              }
          
              //this.deleteData(id)
              })

      },
  }
}
</script>